/** Temporary placeholder for screens still being built from Figma. */
export function StubScreen({ title }: { title: string }) {
  return (
    <div className="push-enter flex min-h-full flex-col px-4 pt-3">
      <div className="flex items-center py-2">
        <h1 className="text-[20px] font-semibold text-ink">{title}</h1>
      </div>
      <div className="mt-10 grid flex-1 place-items-center text-center text-muted">
        <div>
          <p className="text-[15px]">“{title}” screen</p>
          <p className="mt-1 text-[13px]">Building from Figma…</p>
        </div>
      </div>
    </div>
  );
}
